import React, { useState, useEffect,useRef } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Collapse
} from "@mui/material";
import { Box, Card, CardMedia,  CardContent, CardActions, Button,  Popover  } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { apiMain } from "../../App";
import { GetDataPromise } from "../Functions/SendingData";
import CloseIcon from '@mui/icons-material/Close';
import { AppProvider } from '@toolpad/core/AppProvider';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import BRegister from "./BookingRegister";
// فرض می‌کنیم که تصاویر در این مسیر قرار دارند
import Lux1 from "../images/Lux1.jpg";
import Lux2 from "../images/Lux2.jpg";
import Lux3 from "../images/Lux3.jpg";
import Lux4 from "../images/Lux4.jpg";
import Lux5 from "../images/Lux5.jpg";
import Lux6 from "../images/Lux6.jpg";
import Lux7 from "../images/Lux7.jpg";
import Lux8 from "../images/Lux8.jpg";
import Lux9 from "../images/Lux9.jpg";
import Lux10 from "../images/Lux10.jpg";
import Lux11 from "../images/Lux11.jpg";
import Lux12 from "../images/Lux12.jpg";
import Lux13 from "../images/Lux13.jpg";
import Lux14 from "../images/Lux14.jpg";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import BedIcon from "@mui/icons-material/Bed";
import SingleBedIcon from "@mui/icons-material/SingleBed";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import BalconyIcon from "@mui/icons-material/Balcony";
import ParkIcon from "@mui/icons-material/Park";
import TerrainIcon from "@mui/icons-material/Terrain";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import ApartmentIcon from "@mui/icons-material/Apartment";
import YardIcon from "@mui/icons-material/Yard";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import BathtubIcon from "@mui/icons-material/Bathtub";
import TvIcon from "@mui/icons-material/Tv";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import DeckIcon from "@mui/icons-material/Deck";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import WifiIcon from "@mui/icons-material/Wifi";
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SearchIcon from "@mui/icons-material/Search";
import Booking_Reserv from './Booking_Reserv';
import Profile from './Profile';
// و همینطور تصاویر دیگه...
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import BookingHeader from "./BookingHeader";
import BookingFooter from "./BookingFooter";
import BookingReport from "./BookinReport";
const images = [Lux1, Lux2, Lux3,Lux4,Lux5,Lux6,Lux7,Lux8,Lux9,Lux10,Lux11,Lux12,Lux13,Lux14]; // آرایه تصاویر
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
  },
});


export default function Booking() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(false);

  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleSubMenu = () => {
    setOpenSubMenu(!openSubMenu);
  };
  const theme = useTheme();
  const [rooms,setRooms] = useState([
    {
      index:0,
      roomno:0,
    }
  ]);
  const [Index,setIndex]=useState(0);
  const presentsRef = useRef(null);
  const [loginflag ,setLoginFlag] = useState(false)
  const [reservflag ,setReservFlag] = useState(false)
  const [MyMenu ,setMyMenu] = useState(0)
  const [flag ,setFlag] = useState(false)
  useEffect(() => {
    // فرضی: داده‌ها از یک API دریافت می‌شوند
    const fetchData = async () => {
      const data = [
        { index: 0, roomno: 301, isAvailable: false ,price:0 },
        { index: 1, roomno: 302 , isAvailable: false,price:0  },
        { index: 2, roomno: 303 , isAvailable: false ,price:0 },
        { index: 3, roomno: 304 , isAvailable: false,price:0  },
        { index: 4, roomno: 305 , isAvailable: false ,price:0 },
        { index: 5, roomno: 201 , isAvailable: false,price:0  },
        { index: 6, roomno: 202 , isAvailable: false,price:0  },
        { index: 7, roomno: 203 , isAvailable: false ,price:0 },
        { index: 8, roomno: 204 , isAvailable: false,price:0  },
        { index: 9, roomno: 205, isAvailable: false ,price:0  },
        { index: 10, roomno: 102 , isAvailable: false ,price:0 },
        { index: 11, roomno: 103 , isAvailable: false,price:0  },
        { index: 12, roomno: 104 , isAvailable: false ,price:0 },
        { index: 13, roomno: 105 , isAvailable: false,price:0  },
 
      ];
      setRooms(data);
      localStorage.setItem('U_Token','')
      localStorage.setItem('U_Name','')
    };

    fetchData();
  }, []);  // empty dependency array means only run once when component mounts
  useEffect(() => {
    if (rooms.length > 0) {
      roomRate(rooms, 0, 3);
    }
  }, [rooms]);
  
  const changereservFlag=(e)=>{
  setReservFlag(e);
}
const changeLoginFlag=(e)=>{
  setLoginFlag(e);
}
const changeMyMenu=(e)=>{
  setMyMenu(e);
}
  const getRoomData = async (From_Date, To_Date) => {

    let uparams = new URLSearchParams();
    uparams.append("From_Date", From_Date);
    uparams.append("To_Date", To_Date);
      let res = await GetDataPromise(`${apiMain}/api/v1/reservation/checkbookingroomdate?${uparams}`, true);
   let parsed = JSON.parse(res);

    if((parsed.status && parsed.status !== "error") || parsed.status === "success"){
        let newData = parsed.data;
   setRoomData(newData)

   return newData;
    }
   else
    {  setRoomData([])}
       return [];
    }
 const clearRoom=()=>{
  const clear = rooms.map(room => ({
    ...room,
    isAvailable:true,
  }));

  setRooms(clear);
  return clear;
 }
const emailfromtoken= async ()=>{
  try {

    let uparams = new URLSearchParams();
    uparams.append("U_Token", localStorage.getItem('U_Token'));

    const res = await GetDataPromise(`${apiMain}/api/v1/users/selecttoken?${uparams}`, false);
    const parsed = JSON.parse(res);
  
    ChangeEmail(parsed.data[0].U_Name)
    console.log(parsed.data[0].U_Name)
  }
 catch (err) {
  console.error('Email From Token error:', err);
}
}
 const roomRate = async (updatedRooms,temp, presed_id) => {
  try {
    // آماده‌سازی تاریخ با صفرپر کردن
    const dat = new Date(range[0].startDate);
    const day = String(dat.getDate()).padStart(2, '0');
    const mon = String(dat.getMonth() + 1).padStart(2, '0');
    const indate = `${dat.getFullYear()}-${mon}-${day}`;

    let uparams = new URLSearchParams();
    uparams.append("az_date", indate);
    uparams.append("Arze_Id", 1);
    uparams.append("Prese_Id", presed_id);

    const res = await GetDataPromise(`${apiMain}/api/v1/roomfee/selectfee?${uparams}`, false);
    const parsed = JSON.parse(res);

  //  console.log(parsed.data.length)
   // const updatedRooms = [];
    if (parsed.data && parsed.data.length > 0) {
      // فرض: parsed.data[0] آرایه‌ای یا شی‌ای است که feeها را نگه می‌دارد
      for (let i = 0; i < updatedRooms.length; i++) {
        const room = updatedRooms[i];
        // برای هر درخواست پارامتر جدید بساز
        const uparams2 = new URLSearchParams();
        uparams2.append("Room_No", room.roomno);

        const res2 = await GetDataPromise(`${apiMain}/api/v1/room/select?${uparams2}`, false);
        const parsed2 = JSON.parse(res2);

        // اطمینان از وجود داده
        if (parsed2.data && parsed2.data.length > 0 && parsed.data[0]) {
          const roomName = parsed2.data[0].Room_Name +
           (parsed2.data[0].Room_Extra1===null ? '' : parsed2.data[0].Room_Extra1)  +
           ( parsed2.data[0]?.Room_Extra2 ===null ? '' : parsed2.data[0]?.Room_Extra2)  ; // نام فیلد فرضی
          // ممکنه parsed.data[0] یک شی باشه که کلیدها نام اتاق هستن:
        
          const feeValue = parsed.data[0][roomName];
  // console.log(feeValue)
          // به‌روزرسانی آرایه updatedRooms با ایندکس i
          updatedRooms[i] = {
            ...updatedRooms[i],
            price: feeValue
          };
        }
      }
    //   console.log(updatedRooms)
    // setRooms(updatedRooms);
    }
  } catch (err) {
    console.error('roomRate error:', err);
  }
};

const HandelRoom=async (startDate,endDate)=>{
  let az = startDate;
  let ta=endDate;
  const clear = clearRoom(); // آرایه آپدیت‌شده برای ادامه کار
   const updatedRooms = [...clear];
   const azmonth =az.getMonth()+1;
   const tamonth=ta.getMonth()+1;

     let From_Date =az.getFullYear()+ '-'+ azmonth + '-'+ az.getDate() ;
     let To_Date =ta.getFullYear()+ '-'+ tamonth  + '-'+ ta.getDate() ;

 const Rdata=await getRoomData(From_Date,To_Date)


  //console.log(roomdata)
    // حلقه روی داده‌های برگشتی از دیتابیس
  // console.log(Rdata)
  if (Rdata !==[])
  Rdata.map(res => {
      const index = updatedRooms.findIndex(room => room.roomno === res.Room_Number);
      if(index !== -1){
 
            updatedRooms[index] = {
          ...updatedRooms[index],
          isAvailable: false
        };
      }
    });console.log(updatedRooms)
 roomRate(updatedRooms,0,3);
    setRooms(updatedRooms);

   
}

 // const params = useParams()
  const [roomdata, setRoomData] = useState();
  const features = [
    { icon: <SingleBedIcon fontSize="small" />, label: "Twin beds" },
    { icon: <BedIcon fontSize="small" />, label: "1 Queen bed" },
    { icon: <RestaurantIcon fontSize="small" />, label: "Restaurant" },
    { icon: <BalconyIcon fontSize="small" />, label: "Balcony" },
    { icon: <ParkIcon fontSize="small" />, label: "Garden view" },
    { icon: <TerrainIcon fontSize="small" />, label: "Mountain view" },
    { icon: <LocationCityIcon fontSize="small" />, label: "Landmark view" },
    { icon: <ApartmentIcon fontSize="small" />, label: "City view" },
    { icon: <YardIcon fontSize="small" />, label: "Inner courtyard view" },
    { icon: <AcUnitIcon fontSize="small" />, label: "Air conditioning" },
    { icon: <BathtubIcon fontSize="small" />, label: "Private bathroom" },
    { icon: <TvIcon fontSize="small" />, label: "Flat-screen TV" },
    { icon: <VolumeOffIcon fontSize="small" />, label: "Soundproof" },
    { icon: <DeckIcon fontSize="small" />, label: "Terrace" },
    { icon: <LocalBarIcon fontSize="small" />, label: "Minibar" },
    { icon: <WifiIcon fontSize="small" />, label: "Free Wifi" },
  ];
  const [email, setEmail] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
const HandelLoginFlag=(event)=>{
  if (!flag){

    setLoginFlag(true)
  }
}
const HandelBooking=(index)=>
{
  if (localStorage.getItem('U_Token')==='')
  {  setLoginFlag(true);
  setIndex( index)}
  else
  {
    emailfromtoken();
    setReservFlag(true);
  console.log(email)
  }

}

const ChangeEmail=(event)=>{
  setEmail(event)
}
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);
switch (MyMenu) {
  case 0:
    
    return (
      <>
              <Box sx={{flexGrow: 1, display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        {/* Header */}
   
      <BookingHeader changeLoginFlag={changeLoginFlag}  changeMyMenu={changeMyMenu}/>
      <Box
  sx={{
    mt: 3,  // این رو حذف کنید
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    border: "3px solid #FFD43B",
    borderRadius: "10px",
    boxShadow: 1,
    p: 1.2,
    gap: 1,
    maxWidth: 600,
    mx: "auto",

    position: "fixed",   // ثابت کردن باکس تاریخ
    top: "40px",         // فاصله از بالای صفحه به اندازه ارتفاع AppBar
    left: "50%",         // وسط چین افقی
    transform: "translateX(-50%)",  // مرکز کردن افقی
    zIndex: 999,         // روی تمام المان‌ها قرار بگیرد
    padding: "10px",     // کمی فاصله از کناره‌ها
    boxSizing: "border-box",  // اطمینان از اینکه padding روی اندازه کلی اثر نگذارد
  }}
    >
      {/* انتخاب تاریخ */}
      <Box
        onClick={handleOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 1,
          border: "1px solid #ccc",
          borderRadius: "5px",
          cursor: "pointer",
          flex: 1,
          "&:hover": { borderColor: "#1976d2" },
        }}
      >
        <CalendarMonthIcon color="action" />
        <Typography variant="body2">
          {`${range[0].startDate.toLocaleDateString()} - ${range[0].endDate.toLocaleDateString()}`}
        </Typography>
      </Box>

      {/* دکمه جستجو */}
      <Button
        onClick={()=>HandelRoom(range[0].startDate,range[0].endDate)}
        variant="contained"
        color="primary"
        startIcon={<SearchIcon />}
        sx={{
          backgroundColor: "#0071c2",
          "&:hover": { backgroundColor: "#005a99" },
          px: 3,
          py: 1,
          textTransform: "none",
        }}
      >
        Search
      </Button>

      {/* پاپ‌آپ تاریخ */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          style: {
            width: 'auto', // تنظیم عرض
            minWidth: '250px', // حداقل عرض
            maxWidth: '350px', // حداکثر عرض
            height: 'auto', // ارتفاع خودکار
            maxHeight: '400px', // حداکثر ارتفاع
            overflow: 'auto', // در صورتی که محتوا بیشتر باشد، قابلیت اسکرول را اضافه می‌کند
          },
        }}
      >
        <DateRange
          editableDateInputs={true}
          moveRangeOnFirstSelection={false}
          onChange={(item) => setRange([item.selection])}

          ranges={range}
          rangeColors={['#1976d2']}
          showDateDisplay={true}  // نمایش تاریخ ماه و سال
          months={1}  // می‌تونید ماه‌ها رو تنظیم کنید
          direction="horizontal"  // تعیین جهت نمایش (افقی یا عمودی)
        />
      </Popover>
    </Box>

    <Box
  sx={{
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)", // برای صفحه‌های کوچکتر از 900px یک ستون
    gap: 0.2,
    justifyItems: "center", // وسط‌چین افقی
    alignItems: "center", // وسط‌چین عمودی
    paddingTop: "150px",
  
        "@media (max-width: 900px)": {
      gridTemplateColumns: "1fr", // برای صفحه‌های کوچکتر از ۹۰۰px یک ستون
    },
    "@media (max-width: 600px)": {
      gridTemplateColumns: "1fr", // برای صفحه‌های کوچکتر از ۶۰۰px یک ستون
    },
  }}
>
  {images.map((src, index) => (
    <Box
      key={index}
      sx={{
        display: "grid",
        gridTemplateColumns: "100px 1fr 2fr 1fr", // چهار ستون: تصویر، قیمت، توضیحات، دکمه
        gap: 0.2,
        alignItems: "center", // وسط‌چین عمودی
        backgroundColor: "#f5f5f5",
        borderRadius: 2,
        padding: 1,
        height:'80px',
        width: "90%", // عرض کارت‌ها کمتر از 50% از صفحه (90% از عرض container)
        maxWidth: "600px", // حداکثر عرض کارت‌ها
        boxShadow: 2,
        margin: "auto", // مرکز کردن کارت‌ها در صفحه

      }}
    >
      {/* تصویر اتاق */}
      <CardMedia
        component="img"
        image={src}
        alt={`Room ${index}`}
        sx={{
          width: "100px", // عرض تصویر کوچک
          height: "50px", // ارتفاع تصویر
          objectFit: "cover",
          borderRadius: "8px",
        }}
      />



      {/* توضیحات اتاق */}
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="body2" sx={{ marginTop: 1,height:'50px',fontSize:'12px'  }}>
  
        <div>
    { features[1].icon},
       { features[1].label}
        </div>
   
        <div>
                { features[2].icon},
       { features[2].label}
        </div>
 
        </Typography>
      </Box>
      {/* قیمت اتاق */}
      <Box sx={{ textAlign: "center" }}>

        <Typography variant="h1" sx={{ color: "#1976d2",height:'50px',fontSize:'12px' }}>
        Room No:  {rooms[index]?.roomno}
          </Typography>
        <Typography variant="h6" sx={{ color: "#1976d2",height:'50px',fontSize:'12px' }}>
          {`price: ${rooms[index]?.price} $`}
        </Typography>
      </Box>
      {/* دکمه رزرو */}
      <Box sx={{ textAlign: "center"  }}>
        <Button
        style={{height:'40px',fontSize:'12px',width:'90px'}}
          variant="contained"
          color="primary"
          disabled={!rooms[index]?.isAvailable}
          onClick= {()=>HandelBooking(index)} 
         
        >
         Booking
        </Button>
      </Box>
    </Box>
  ))}
</Box>



        {/* Footer */}
        <BookingFooter /> 
        {/* <Box sx={{ backgroundColor: "primary.main", padding: "10px", textAlign: "center" }}>
          <Typography variant="body2" color="white">
            این یک فوتر نمونه است
          </Typography>
        </Box> */}
      </Box>




      <Dialog open={loginflag}
     >
      <IconButton
        aria-label="close"
        onClick={() => setLoginFlag(false)}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
              }}
      >
        <CloseIcon  />
      </IconButton>

      <AppProvider theme={theme}>
        <BRegister ChangeEmail={ChangeEmail} changereservFlag={changereservFlag}  changeLoginFlag={changeLoginFlag} />


      </AppProvider>
    </Dialog>
    <Dialog open={reservflag} 
     PaperProps={{
      sx: {
          maxWidth: 1000,
          maxHeight: 700,
          width: 1500,
          height: 500,
          backgroundColor: '#F2F2F2'
      },
      component: 'form',

  }}
     >
      <IconButton
        aria-label="close"
        onClick={() => setReservFlag(false)}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
       color: theme.palette.grey[500],
              }}
      >
        <CloseIcon />
      </IconButton>

      <AppProvider theme={theme}>
      {/* <Reservation   ref={presentsRef} Room_No={Room_Number} ChangeXpage={ChangeXpage} Reserv_Id={Reserv_Id} getDataCard={getData}  Reserv_Type={Reserv_Type} kk={2} /> */}

      <Booking_Reserv   ref={presentsRef} changereservFlag={changereservFlag} Email={email}  Room_No= {rooms[Index]?.roomno} StartDate={range[0].startDate} EndDate={range[0].endDate} />

      </AppProvider>
    </Dialog>
      </>
    );
    break;
  
  case 1:
      return(
        <>
     <Box sx={{flexGrow: 1, display: "flex", flexDirection: "column", minHeight: "95vh" }}>
          <BookingHeader changeLoginFlag={changeLoginFlag}  changeMyMenu={changeMyMenu}/>
          <Profile  changeMyMenu={changeMyMenu}/>
        
          </Box>
            <BookingFooter />
        </>

      )    
       break;
       case 2:
        return(
          <>
       <Box sx={{flexGrow: 1, display: "flex", flexDirection: "column", minHeight: "95vh" }}>
            <BookingHeader changeLoginFlag={changeLoginFlag}  changeMyMenu={changeMyMenu}/>
            <BookingReport  changeMyMenu={changeMyMenu}/>
          
            </Box>
              <BookingFooter />
          </>
  
        )    
         break;
}
}